import React from "react";
import { StatusBar } from "react-native";
// import Orientation from "react-native-orientation-locker";
import VideoOverlayModal from "@components/VideoOverlayModal";
import { GetVideoTimeContextProvider } from "../../utils/useGetVideoTime";
import VideoContainer from "./VideoContainer";

const VideoModal = (props) => {
  const {
    show,
    setShow,
    video_link = "",
    onEnd,
    hideCloseIcon,
    pausedEventTrack,
    resumedEventTrack,
  } = props;

  const closeModal = () => {
    setShow(!show);
    // Orientation.lockToPortrait();
    StatusBar.setHidden(false);
    StatusBar.setBarStyle("dark-content");
  };

  return (
    <VideoOverlayModal
      visible={show}
      onClose={closeModal}
      hideClose={hideCloseIcon}
    >
      <GetVideoTimeContextProvider>
        <VideoContainer
          {...{ video_link, onEnd, pausedEventTrack, resumedEventTrack }}
          handleCta={closeModal}
        />
      </GetVideoTimeContextProvider>
    </VideoOverlayModal>
  );
};

export default VideoModal;
